// Navigation des Moduls `macapp` (eager geladen). Besitzer: Modul macapp.
// Keine Navigationseinträge: Bar for Mac ist ein eigener Client (Electron). Installation und Geräte
// zeigt die Connect-Seite der KI-Plattform (Modul ki, F-ki-12).
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'macapp',
  title: 'Bar for Mac',
});
